/**
 * Single-key shortcuts for the shell work actions. Tooltips and the
 * global shortcut hook both import from here so the labels cannot drift
 * from the bindings.
 */
export const ACTION_SHORTCUTS = {
  next: "N",
  ask: "A",
  create: "C",
  search: "/",
} as const;
